import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { PopupService } from '../../../services/popup.service';

@Component({
  selector: 'app-cms-actions',
  templateUrl: './cms-actions.component.html',
})
export class CmsActionsComponent {
  @Input() public itemId: number | null;
  @Input() public itemType: number | null;

  @Output() public saveItem: EventEmitter<void> = new EventEmitter();
  @Output() public deleteItem: EventEmitter<void> = new EventEmitter();

  @ViewChild('deletePopup', { static: true }) deletePopup: ElementRef;

  constructor(private popupService: PopupService) {}

  get mainDeleteTextLangVar(): string {
    return `delete_popup_main_text_${this.itemType}`;
  }

  get helperDeleteTextLangVar(): string {
    return `delete_popup_helper_text_${this.itemType}`;
  }

  openDeleteConfirmPopup(): void {
    this.popupService.showPopup(this.deletePopup);
  }
}
